import React, { useEffect } from "react";
import { Input, FormFeedback, InputGroup, InputGroupText, Row, Col } from "reactstrap";
import { useFormik } from "formik";
import { CommissionsFormSchema } from "model/_base/products/commission.schema";

export const CommissionsForm = ({ onSubmit, onValidationChange, initialValue = "" }) => {
  const formik = useFormik({
    initialValues: { commissionsRate: initialValue },
    validationSchema: CommissionsFormSchema,
    onSubmit: (values) => {
      formik.resetForm();
      onSubmit(values.commissionsRate);
    },
  });

  useEffect(() => {
    if (formik.values.commissionsRate && !formik.errors.commissionsRate) {
      onSubmit(formik.values.commissionsRate);
    }
  }, [formik.values.commissionsRate, formik.errors.commissionsRate]);

  useEffect(() => {
    if (onValidationChange) {
      const isValid = formik.values.commissionsRate && !formik.errors.commissionsRate;
      onValidationChange(isValid);
    }
  }, [formik.values.commissionsRate, formik.errors.commissionsRate, onValidationChange]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="d-flex flex-column gap-2">
        <Row>
          <Col xs={3}>
            <div className="fw-semibold text-xl whitespace-nowrap">ค่าคอมมิชชันใหม่ (ที่ต้องการ)</div>
          </Col>
          <Col xs={9}>
            <InputGroup>
              <Input key="commissionsRate" name="commissionsRate" type="number" placeholder="กรุณาใส่ % เรทของค่าคอมมิชชันที่ต้องการ ยกตัวอย่าง 3.5%" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.commissionsRate} invalid={formik.touched.commissionsRate && formik.errors.commissionsRate} data-testid="commissions-rate-input" />
              <InputGroupText>%</InputGroupText>
            </InputGroup>
            {formik.touched.commissionsRate && formik.errors.commissionsRate && <FormFeedback>{formik.errors.commissionsRate}</FormFeedback>}
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className="text-danger-600 text-xl">
              <b>หมายเหตุ : </b>ระบบจะคำนวนจากยอดของราคาสินค้า by total product นำมาคิดเป็น % เช่น กรณีถ้าสินค้าลดราคาระบบก็จะนำราคาสินค้าที่ลดราคาแล้วมาคำนวน % ตาม rate ที่ได้ตั้งค่าไว้
            </div>
          </Col>
        </Row>
      </div>
    </form>
  );
};
